

























import { Component } from "../../../Infrastructure/CorBase/CoreBase";
import PersonListBase from "./PersonListBase";

@Component
export default class PersonList extends PersonListBase {

	created() {
		super.initializeRights('COR_Person_Create', 'COR_Person_Delete', 'COR_Person_Read', 'COR_Person_Update');
		super.created();
		super.setDetailName('PersonDetail');
	};


	showAllertToDeleteClick(itemsSelected: any) {
		this.showAlertBeforeActionClickBase(itemsSelected, this.$t('person.messageQuestionMain').toString());
	}

	loadFilters(value: any) { super.loadFilters(value); }
	createNewClick(elementId: any) { super.createNewClick(elementId); }
	detailClick(elementId: any) { super.detailClick(elementId); }
	deleteClick(elementId: any) { super.deleteClick(elementId); }

};
